import React from 'react';
import { DndContext, type DragEndEvent } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import type CustomFieldsCategory from '../../types/CustomFieldsCategory';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import CustomFieldsDraggable from './CustomFieldsDraggable';

function CustomFieldsSection({
  customFields,
  label,
  expandedItem,
  onDragEnd,
  onExpand,
}: CustomFieldsCategory & {
  expandedItem: string;
  onDragEnd: (event: DragEndEvent) => void;
  onExpand: (fieldId: string) => void;
}) {
  const items = React.useMemo(
    () => customFields.map(({ customFieldId }) => customFieldId),
    [customFields],
  );

  if (!customFields.length) return null;

  return (
    <DndContext onDragEnd={onDragEnd} modifiers={[restrictToVerticalAxis]}>
      <div className="pt-8">
        <h3 className="type-h3">{label}</h3>
        <SortableContext items={items} strategy={verticalListSortingStrategy}>
          {customFields.map((field) => (
            <CustomFieldsDraggable
              key={field.customFieldId}
              field={field}
              isExpanded={expandedItem === field.customFieldId}
              onExpand={onExpand}
            />
          ))}
        </SortableContext>
      </div>
    </DndContext>
  );
}

export default CustomFieldsSection;
